import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import './VenteBanner.scss';

const VenteBanner = ({ title, image, content }) => {
  return (
    <div
      className="services-vente"
      style={{ backgroundColor: '#F5F5F5', paddingTop: 15, paddingBottom: 30 }}
    >
      <div className="container">
        <center>
          <h1>{title}</h1>
        </center>

        <div style={{ paddingTop: 10 }} className="services-vente-content row">
          <div className="col-lg-6 mb-3">
            <Img alt={image.title} sizes={image.sizes} />
          </div>
          <div className="col-lg-6">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    </div>
  );
};

VenteBanner.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
};

export default VenteBanner;



// WEBPACK FOOTER //
// ./src/components/Main/services/VenteBanner.js